import {
  HubFrequentDriverListSearchCriteria,
  HubFrequentDriverSearchCriteria,
} from '../../models/hub-frequent-driver-list.model';
import { HubFrequentDriverModel } from '../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

export class HubFrequentDriverListLoad {
  public static readonly type = '[HubFrequentDriverList] Load Driver List';

  constructor(public payload: HubFrequentDriverListSearchCriteria) {}
}

export class HubFrequentDriversSearch {
  public static readonly type = '[HubFrequentDriverList] Drivers Search';

  constructor(public hubId: number, public payload: HubFrequentDriverSearchCriteria) {}
}

export class HubFrequentDriversClearSearch {
  public static readonly type = '[HubFrequentDriverList] Drivers Clear Search';
}

export class HubFrequentDriverListItemDelete {
  public static readonly type = '[HubFrequentDriverList] Delete Driver List Item';

  constructor(
    public payload: {
      hubId: number;
      driverId: number;
      dialogRef: MatDialogRef<unknown>;
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
    },
  ) {}
}

export class HubFrequentDriverListItemCreate {
  constructor(public driver: HubFrequentDriverModel) {}
}

//TODO: check where it's used
export class HubFrequentDriverListItemSave {
  public static readonly type = '[HubFrequentDriverList] Save Driver Item';

  constructor(public driver: HubFrequentDriverModel, public dialogRef: MatDialogRef<unknown>) {}
}

export class HubFrequentDriverListInitialState {
  public static readonly type = '[HubFrequentDriverList] Set Initial State';
}
